module.exports = __webpack_public_path__ + "img/logo-img.de8dcca8.png";